import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Marquee } from "@/components/Marquee";
import { Seo } from "@/components/Seo";
import { Hero } from "@/sections/Hero";
import { Categories } from "@/sections/Categories";
import { WhyUs } from "@/sections/WhyUs";
import { AvailabilityBoard } from "@/components/AvailabilityBoard";
import { RequirementBuilder } from "@/components/RequirementBuilder";
import { GpuFeature } from "@/sections/GpuFeature";
import { GlobalMap } from "@/components/GlobalMap";
import { Process } from "@/sections/Process";
import { Confidence } from "@/sections/Confidence";
import { Sectors } from "@/sections/Sectors";
import { RfqCta } from "@/sections/RfqCta";

import { RoyalAi } from "@/components/RoyalAi";

export default function Home() {
  return (
    <div className="bg-white min-h-screen" data-testid="home-page">
      <Seo
        title="Royal Deals FZ-LLC — Advanced Compute & AI Infrastructure Supply, UAE"
        description="Enterprise GPUs, AI infrastructure and high-performance computer components. UAE-based sourcing and distribution for data centres, integrators, enterprises and technology partners."
      />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Categories />
        <WhyUs />
        <AvailabilityBoard />
        <RequirementBuilder />
        <GpuFeature />
        <GlobalMap />
        <Process />
        <Confidence />
        <Sectors />
        <RfqCta />
      </main>
      <Footer />
      <RoyalAi />
    </div>
  );
}
